import { hasEarlyAccessCapability } from '@/services/authorization.service';
import {
  isConfigurationLoaded,
  knowledgeManagementEnabled as knowledgeManagementFeatureEnabled,
} from '@/services/systemConfiguration.utilities';

export function knowledgeManagementEnabled(): boolean {
  if (!isConfigurationLoaded()) return false;
  return Boolean(knowledgeManagementFeatureEnabled()) && hasEarlyAccessCapability();
}
